import { defineMessages } from 'react-intl';

export default defineMessages({
    additionalInterests: {
        id: 'wmic.pe-capability-quoteandbind-common-react.pages.additional-interest-table.additional-interests',
        defaultMessage: 'Additional Interests'
    },
})
